import React from "react";
import { Layout, Row, Col, Typography, Grid } from "antd";
import { InstagramOutlined, FacebookOutlined } from "@ant-design/icons";
import { useNavigate } from "react-router-dom";

const { Footer } = Layout;
const { Text } = Typography;
const { useBreakpoint } = Grid;

const CommonFooter = ({ showInWhite = false }) => {
  const navigate = useNavigate();
  const screens = useBreakpoint();
  const isMobile = !screens.md;

  const textColor = showInWhite ? "#ffffff" : "#000000";
  const linkColor = showInWhite ? "#ffffff" : "#000000";
  const linkHoverColor = showInWhite ? "#cccccc" : "#666666";

  const linkStyle = {
    color: linkColor,
    textDecoration: "none",
    transition: "color 0.3s ease",
    fontWeight: 500,
    padding: isMobile ? "2px 4px" : "0 6px",
    cursor: "pointer",
    fontSize: isMobile ? "13px" : "14px",
    display: "inline-block",
  };

  const dividerStyle = {
    color: linkColor,
    margin: isMobile ? "0 2px" : "0 4px",
    fontWeight: 500,
    fontSize: isMobile ? "12px" : "14px",
  };

  // ✅ All navigation links in one array
  const links = [
    { name: "Terms of Use", path: "/terms" },
    { name: "Privacy", path: "/privacy" },
    { name: "Cookie Preferences", path: "/cookie-policy" },
    { name: "Contact Us", path: "/contact-us" },
  ];

  return (
    <Footer
      style={{
        backgroundColor: "transparent",
        color: textColor,
        padding: isMobile ? "20px 15px" : "25px 40px",
        fontSize: isMobile ? "13px" : "14px",
        borderTop: showInWhite
          ? "1px solid rgba(255,255,255,0.2)"
          : "1px solid #ddd",
      }}
    >
      <Row
        justify="space-between"
        align={isMobile ? "top" : "middle"}
        gutter={isMobile ? [0, 15] : [0, 0]}
      >
        {/* Left Text */}
        <Col
          xs={24}
          md={12}
          style={{
            textAlign: isMobile ? "center" : "left",
            order: isMobile ? 2 : 1,
          }}
        >
          <Text
            style={{
              color: textColor,
              fontSize: isMobile ? "12px" : "14px",
            }}
          >
            © 2025 notinthemarket.com &nbsp; | &nbsp; All rights reserved.
          </Text>
        </Col>

        {/* Right Links + Social Icons */}
        <Col
          xs={24}
          md={12}
          style={{
            textAlign: isMobile ? "center" : "right",
            display: "flex",
            justifyContent: isMobile ? "center" : "flex-end",
            alignItems: "center",
            flexWrap: "wrap",
            gap: isMobile ? "2px" : "4px",
            color: textColor,
            order: isMobile ? 1 : 2,
          }}
        >
          {/* All navigation links */}
          {links.map((item, index, arr) => (
            <React.Fragment key={item.name}>
              <span
                style={linkStyle}
                onClick={() => navigate(item.path)}
                onMouseOver={(e) => (e.target.style.color = linkHoverColor)}
                onMouseOut={(e) => (e.target.style.color = linkColor)}
              >
                {item.name}
              </span>
              {index !== arr.length - 1 && <span style={dividerStyle}>|</span>}
            </React.Fragment>
          ))}

          {/* Divider before Social Icons */}
          <span style={dividerStyle}>|</span>

          {/* Instagram Icon */}
          <a
            href="https://www.instagram.com/not_inthemarket/"
            target="_blank"
            rel="noopener noreferrer"
            style={{
              color: linkColor,
              fontSize: isMobile ? 16 : 18,
              padding: isMobile ? "0 4px" : "0 6px",
              transition: "color 0.3s ease",
              display: "inline-flex",
              alignItems: "center",
            }}
            onMouseOver={(e) => (e.target.style.color = linkHoverColor)}
            onMouseOut={(e) => (e.target.style.color = linkColor)}
          >
            <InstagramOutlined />
          </a>

          {/* Facebook Icon */}
          <a
            href="https://www.facebook.com/profile.php?id=61583321927199"
            target="_blank"
            rel="noopener noreferrer"
            style={{
              color: linkColor,
              fontSize: isMobile ? 16 : 18,
              padding: isMobile ? "0 4px" : "0 6px",
              transition: "color 0.3s ease",
              display: "inline-flex",
              alignItems: "center",
            }}
            onMouseOver={(e) => (e.target.style.color = linkHoverColor)}
            onMouseOut={(e) => (e.target.style.color = linkColor)}
          >
            <FacebookOutlined />
          </a>
        </Col>
      </Row>
    </Footer>
  );
};

export default CommonFooter;
